import Vue from "vue";
import Router from "vue-router";
import Navbar from "@/components/layout/Navbar";
import ManageNavbar from "@/components/manage/index";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: "/billboard"
    },
    {
      path: "/billboard",
      name: "billboard",
      component: () =>
        import ("@/components/billboard/index")
    },
    {
      path: "/control/",
      name: "control",
      component: Navbar,
      redirect: "/control/index",
      children: [{
        path: "/control/index",
        name: "control_index",
        component: () =>
          import ("@/components/control/index"),
        redirect: "/control/all",
        children: [
          {
            path: "/control/branch_control",
            name: "control_branch_control",
            component: () =>
              import ("@/components/control/branch_control/index")
          },
          {
            path: "/control/all",
            name: "control_all",
            component: () =>
              import ("@/components/control/All")
          },
          {
            path: "/control/building/:building_id",
            name: "control_building",
            component: () =>
              import ("@/components/control/Building")
          },
          {
            path: "/control/floor/:floor_id",
            name: "control_floor",
            component: () =>
              import ("@/components/control/Floor")
          },
          {
            path: "/control/classroom/:gateway_id",
            name: "control_classroom",
            component: () =>
              import ("@/components/control/Classroom")
          }
        ]
      }]
    },
    {
      path: "/manage/",
      name: "manage",
      component: Navbar,
      redirect: "/manage/index",
      children: [{
        path: "/manage/index",
        name: "build",
        component: ManageNavbar,
        redirect: "/manage/build",
        children: [{
          path: "/manage/build",
          name: "manage_build",
          component: () =>
            import ("@/components/manage/build/index")
        },
          {
            path: "/manage/device",
            name: "manage_device",
            component: () =>
              import ("@/components/manage/device/index")
          },
          {
            path: "/manage/user",
            name: "manage_user",
            component: () =>
              import ("@/components/manage/user/index")
          },
          {
            path: "/manage/alarm",
            name: "manage_alarm",
            component: () =>
              import ("@/components/manage/alarm/index")
          },
          {
            path: "/manage/electricQuantity",
            name: "manage_electric_quantity",
            component: () =>
              import ("@/components/manage/electricQuantity/index")
          },
          {
            path: "/manage/scene",
            name: "manage_scene",
            component: () =>
              import ("@/components/manage/scene/index")
          },
          {
            path: "/manage/lora",
            name: "manage_lora",
            component: () =>
              import ("@/components/manage/lora/index")
          }
        ]
      }]
    },
    {
      path: "/data/",
      name: "data",
      component: Navbar,
      redirect: "/data/index",
      children: [{
        path: "/data/index",
        name: "data_index",
        component: () =>
          import ("@/components/data/index"),
        // redirect: "/data/power_total",
        redirect: () => {
          if (has_sub_module_permission("data_electricity")) {
            return "/data/power_total";
          }
          if (has_sub_module_permission("data_warn")) {
            return "/data/warning_count";
          }
          if (has_sub_module_permission("data_count")) {
            return "/data/use_counts";
          }
          if (has_sub_module_permission("data_export")) {
            return "/data/export";
          }
        },
        children: [{
          path: "/data/power_total",
          name: "power_total",
          component: () =>
            import ("@/components/data/power_total/index")
        },
          {
            path: "/data/warning_count",
            name: "warning_count",
            component: () =>
              import ("@/components/data/warning_count/index")
          },
          {
            path: "/data/use_counts",
            name: "use_counts",
            component: () =>
              import ("@/components/data/use_counts/index")
          },
          {
            path: "/data/human_detection",
            name: "human_detection",
            component: () =>
              import ("@/components/data/human_detection/index")
          },
          {
            path: "/data/sterilize_total",
            name: "sterilize_total",
            component: () =>
              import ("@/components/data/sterilize_total/index")
          },
          {
            path: "/data/export",
            name: "data_export",
            component: () =>
              import ("@/components/data/data_export/index")
          }
        ]
      }]
    },
    {
      path: "/log/",
      name: "log",
      component: Navbar,
      redirect: "/log/index",
      children: [{
        path: "/log/index",
        name: "log_index",
        component: () =>
          import ("@/components/log/index"),
        // redirect: "/log/user",
        redirect: () => {
          if (has_sub_module_permission("log_user")) {
            console.log("user");
            return "/log/user";
          }
          if (has_sub_module_permission("log_device")) {
            console.log("device");
            return "/log/device";
          }
          if (has_sub_module_permission("log_task")) {
            console.log("task");
            return "/log/task";
          }
          if (has_sub_module_permission("log_warn")) {
            console.log("warn");
            return "/log/warn";
          }
          if (has_sub_module_permission("log_manage")) {
            console.log("mange");
            return "/log/manage";
          }
        },

        children: [{
          path: "/log/user",
          name: "log_user",
          alias: "/b",
          component: () =>
            import ("@/components/log/User")
        },
          {
            path: "/log/device",
            name: "log_device",
            component: () =>
              import ("@/components/log/Device")
          },
          {
            path: "/log/task",
            name: "log_task",
            component: () =>
              import ("@/components/log/Task")
          },
          {
            path: "/log/warn",
            name: "log_warn",
            component: () =>
              import ("@/components/log/Warn")
          },
          {
            path: "/log/manage",
            name: "log_manage",
            component: () =>
              import ("@/components/log/Manage")
          }
        ]
      }]
    },
    {
      path: "/task/",
      name: "task",
      component: Navbar,
      redirect: "/task/index",
      children: [{
        path: "/task/index",
        name: "task_index",
        component: () =>
          import ("@/components/task/index"),
        redirect: "/task/manage",
        children: [{
          path: "/task/manage",
          name: "task_manage",
          component: () =>
            import ("@/components/task/task/index")
        },
          {
            path: "/strategy/manage",
            name: "strategy_manage",
            component: () =>
              import ("@/components/task/strategy/index")
          }
        ]
      }]
    },
    {
      path: "/login",
      component: () =>
        import ("@/components/auth/Login")
    }
  ]
});

function is_login() {
  let token = localStorage.getItem("token");
  let username = localStorage.getItem("username");
  if (token && username) {
    return true;
  } else {
    return false;
  }
}

function has_sub_module_permission(module_name) {
  const can_all = localStorage.getItem("can_all");
  const module_permissions = JSON.parse(
    localStorage.getItem("module_permissions")
  );
  if (JSON.parse(can_all)) {
    return true;
  }

  // 判断是否有此模块的权限
  if (module_permissions) {
    const {control, cron, log, data, system} = module_permissions;
    const all_permissions = {
      ...control,
      ...cron,
      ...log,
      ...data,
      ...system
    };

    return all_permissions[module_name].read;
  } else {
    return false;
  }
}

router.beforeEach((to, from, next) => {
  if (to.path !== "/login") {
    if (!is_login()) {
      next({
        path: "/login",
        query: {redirect: to.fullPath}
      });
    } else {
      next();
    }
  } else {
    next(); // 确保一定要调用 next()
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js